import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'

export const PlannedAccessesElaborationsCard = ({
    totalProcessingAccesses,
    totalReportingAccessCount,
    unaccountedTotal
}: {
    totalProcessingAccesses: number
    totalReportingAccessCount: number
    unaccountedTotal: number
}) => {
    const {t} = useTranslation()

    return (
        <FormCardSection columns={3} padding={3}>
            <DetailsField>
                <Text size="textSm" weight="400" palette="neutral" shade="600">
                    {t('planned_accesses:elaboration_project_field_title')}
                </Text>
                <Text size="textSm" weight="500">
                    {totalProcessingAccesses}
                </Text>
            </DetailsField>
            <DetailsField>
                <Text size="textSm" weight="400" palette="neutral" shade="600">
                    {t('planned_accesses:reporting_accesses_field_title')}
                </Text>
                <Text size="textSm" weight="500">
                    {totalReportingAccessCount}
                </Text>
            </DetailsField>
            <DetailsField>
                <Text size="textSm" weight="400" palette="neutral" shade="600">
                    {t('planned_accesses:unaccounted_accesses_field_title')}
                </Text>
                <Text size="textSm" weight="500">
                    {unaccountedTotal}
                </Text>
            </DetailsField>
        </FormCardSection>
    )
}
